import { render, staticRenderFns } from "./ConsignmentDetails.vue?vue&type=template&id=40ffca88&scoped=true&"
import script from "./ConsignmentDetails.vue?vue&type=script&lang=js&"
export * from "./ConsignmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConsignmentDetails.vue?vue&type=style&index=0&id=40ffca88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ffca88",
  null
  
)

export default component.exports